(() => {
  const PRODUCT_PATH = '/products/mobnano-gpm-for-iphone-17-case';
  const TARGET_COLOR = 'Black/Orange';
  const FEATURED_MEDIA_BY_SIZE = {
    'iPhone 17': 'mobnano-gpm-17-black-orange-01',
    'iPhone 17 Pro Max': 'mobnano-gpm-17pm-black-orange-01',
  };

  function optionName(input) {
    const name = (input.getAttribute('name') || '').trim();
    const bracketMatch = name.match(/^options\[(.+)]$/);
    if (bracketMatch) return bracketMatch[1].trim();
    return name.split('-')[0].trim();
  }

  function selectedOptions(productInfo) {
    const options = {};
    productInfo.querySelectorAll('variant-selects input:checked, variant-selects select').forEach((input) => {
      const name = optionName(input);
      if (!name) return;
      options[name] = input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent?.trim() : input.value;
    });
    return options;
  }

  function matchesMedia(element, fileToken) {
    const image = element.querySelector('img');
    if (!image) return false;
    const source = image.currentSrc || image.src || '';
    return source.includes(fileToken);
  }

  function activateMedia(productInfo) {
    const options = selectedOptions(productInfo);
    if (options.Color !== TARGET_COLOR) return;

    const fileToken = FEATURED_MEDIA_BY_SIZE[options.Size];
    if (!fileToken) return;

    const gallery = productInfo.querySelector('media-gallery');
    const thumbnail = Array.from(gallery?.querySelectorAll('[data-target]') || []).find((item) =>
      matchesMedia(item, fileToken)
    );
    const targetMediaId = thumbnail?.dataset.target;
    if (!gallery || !targetMediaId) return;

    const activeImage = gallery.querySelector('.product__media-item.is-active img');
    const activeSource = activeImage?.currentSrc || activeImage?.src || '';
    if (activeSource.includes(fileToken)) return;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(targetMediaId, true);
      return;
    }

    gallery.querySelectorAll('[data-media-id]').forEach((item) => {
      item.classList.toggle('is-active', item.dataset.mediaId === targetMediaId);
    });
    gallery.querySelectorAll('[data-target] button').forEach((button) => button.removeAttribute('aria-current'));
    thumbnail.querySelector('button')?.setAttribute('aria-current', 'true');
  }

  function compatibleProductInfos() {
    return Array.from(document.querySelectorAll('product-info')).filter((productInfo) =>
      (productInfo.dataset.url || '').endsWith(PRODUCT_PATH)
    );
  }

  function scheduleActivation() {
    window.requestAnimationFrame(() => {
      compatibleProductInfos().forEach(activateMedia);
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleActivation);
  document.addEventListener('product-info:loaded', scheduleActivation);
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) scheduleActivation();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, scheduleActivation);
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, scheduleActivation);
  }
})();
